import { store } from "../app/store";

export const defaultCurrency = () => {
  const { hotel } = store.getState();
  const currency = hotel.Currencies.find((c) => c.Code === hotel.Culture.CurrencyCode);
  if (currency) return currency;

  // Default
  return {
    Code: "EUR",
    Symbol: "€",
    ValueFormat: '"€"#,##0.00;−"€"#,##0.00',
    DecimalPlaces: 2,
    SymbolIsBehindValue: false,
  };
};

export const findCurrencyByCode = (code: string) => {
  const { hotel } = store.getState();
  const currency = hotel.Currencies.find((c) => c.Code === code);
  if (currency) return currency;

  // Default
  return defaultCurrency();
};

export const currentCurrencyName = () => {
  const { hotel } = store.getState();
  const currency = findCurrencyByCode(hotel.Culture.CurrencyCode);
  return `(${currency.Symbol}) ${currency.Code}`;
}

export const getCurrencyOptions = (): {[key: string]: string;} => {
  const { hotel } = store.getState();
  const options: {[key: string]: string;} = {};
  hotel.Currencies.forEach((currency) => {
    options[currency.Code] = `(${currency.Symbol}) ${currency.Code}`;
  });
  return options;
}

export const getCurrencySymbol = (
  price: number,
  decimalPlacesOverride?: number,
) => {
  const { hotel } = store.getState();
  const currencyCode = hotel.Culture.CurrencyCode;
  const currency = hotel.Currencies.find((c) => c.Code === currencyCode);
  const configuredDecimalPlaces = Number(currency?.DecimalPlaces);
  const decimalPlaces =
    decimalPlacesOverride ??
    (currencyCode === "ISK"
      ? 0
      : Number.isFinite(configuredDecimalPlaces)
        ? configuredDecimalPlaces
        : 2);
  const formattedPrice =
    decimalPlaces === 0 ? Math.round(price) : price;
  const formatter = new Intl.NumberFormat(hotel.Culture.LanguageCode, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  return formatter.format(formattedPrice).replace(/\s/g, "");
};

export const formatCurrency = (price: number, decimalPlaces?: number) => {
  const newPrice = getCurrencySymbol(price, decimalPlaces);
  return newPrice;
};

export const formatCurrencyNormalPrice = (price: number) => {
  const { hotel } = store.getState();
  const normalPrice = price * hotel.CompetitorPriceRelativeAdjustment

  const newPrice = getCurrencySymbol(normalPrice);
  return newPrice;
};
